export enum ForeignPartnerId {
    avantio = 13,
}
